"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateQuery = void 0;
const immer_1 = require("immer");
exports.updateQuery = (store, query, fn, variables) => {
    let data;
    try {
        data = store.readQuery({
            query,
            variables,
        });
    }
    catch (_a) { }
    if (data) {
        const newData = immer_1.produce(data, fn);
        store.writeQuery({
            query,
            variables,
            data: newData,
        });
    }
};
//# sourceMappingURL=updateQuery.js.map